import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { Icon, Button } from 'shared/components';
import { CancelButton } from 'modules/common/components/_buttons';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './UpdateAppointmentDiscardModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const UpdateAppointmentDiscardModal = ({ intl, onCancel, onOk }) => (
  <React.Fragment>
    <div className={ theme.header }>
      <div>
        <FormattedMessage
          id="Patient.Appointment.EditAppointment.Cancel.DiscardChanges.Title"
          defaultMessage="** Discard changes"
        />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body }>
      <FormattedMessage
        id="Patient.Appointment.EditAppointment.Cancel.DiscardChanges.Body"
        defaultMessage="** You have unsaved changes. Are you sure you want to discard your changes?"
      />
    </div>

    <div className={ theme.footer }>
      <CancelButton
        label={ intl.formatMessage({
          id: 'Patient.Appointment.EditAppointment.Cancel.DiscardChanges.Cancel.Button',
          defaultMessage: '** Wait, not yet',
        }) }
        handleCancelClick={ onCancel }
        isDisabled={ false }
      />

      <Button
        testId="close-appointment-discard-modal"
        label={ intl.formatMessage({
          id: 'Patient.Appointment.EditAppointment.Cancel.DiscardChanges.Discard.Button',
          defaultMessage: '** Discard',
        }) }
        onClick={ onOk }
        background="red"
      />
    </div>
  </React.Fragment>
);

UpdateAppointmentDiscardModal.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(UpdateAppointmentDiscardModal);
